import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectOperdons } from "../../redux/operdon/operdon-slice";
import FillCarsSlider from "../car/fill-cars-slider/fill-cars-slider";
import FillHistoryServices from "../fill-history-services/fill-history-services";
import OperateHome from "../operate/show-home/operate-home";


const OrginalPage = () => {
  const operdons = useSelector(selectOperdons);
  let sections = [
    {
      title: "سرویس های اخیر",
      link: "/all-services",
      component: <OperateHome />,
      bgClass: "bg-light"
    }
  ];
  if ((operdons?.length ?? 0) > 0)
  {
    sections = [
      {
        title: "سرویس های اخیر",
        link: "/all-services",
        component: <OperateHome />,
        bgClass: "bg-light"
      },
      // {
      //   title: "سرویس های کارکردی",
      //   link: "/all-services",
      //   component: <FillWorkServices />,
      //   bgClass: "bg-light"
      // },
      // {
      //   title: "سرویس های تقویمی",
      //   link: "/all-services", 
      //   component: <FillCalendarServices />,
      //   bgClass: "bg-white"
      // },
      {
        title: "سوابق",
        link: "/all-operdon",
        component: <FillHistoryServices />,
        bgClass: "bg-white"
      }
    ];
  }

 
  return (
    <Fragment>
  {/* اسلایدر ماشین‌ها */}
  <section className="container-fluid px-0 mb-4">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <FillCarsSlider />
        </div>
      </div>
    </div>
  </section>

  {/* بخش‌های داینامیک */}
  {sections.map((section, index) => (
    <section key={index} className={`py-5 ${section.bgClass}`}>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
          <h2 className="h4 mb-2 fw-bold text-primary">{section.title}</h2>
          <Link
            to={section.link}
            className="btn btn-link text-decoration-none p-0"
          >
            نمایش همه →
          </Link>
        </div>
        {section.component}
      </div>
    </section>
  ))}
</Fragment>

    // <Fragment>
    //   {/* اسلایدر ماشین‌ها */}
    //   <section className="col-md-4 container-fluid px-0 px-lg-3">
    //     <div className="container-lg">
    //       <FillCarsSlider />
    //     </div>
    //   </section>

    //   {/* بخش‌های داینامیک */}
    //   {sections.map((section, index) => (
    //     <section key={index} className={`py-5 ${section.bgClass}`}>
    //       <div className="container">
    //         <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
    //           <h2 className="h4 mb-2 mb-md-0 fw-bold text-primary">{section.title}</h2>
    //           <Link
    //             to={section.link}
    //             className="btn btn-link text-decoration-none p-0 mb-2 mb-md-0"
    //           >
    //             نمایش همه →
    //           </Link>
    //         </div>
    //         {section.component}
    //       </div>
    //     </section>
    //   ))}
    // </Fragment>
  );
};

export default OrginalPage;
